import { useUser } from 'modules/user/userSelector';
import { isDevelopmentMode } from 'utils/helpers';
import { isSettingsV2DevOverrideOn } from 'app/config/settingsV2Mode';

const useSettingsV2Gate = () => {
  const { features_toggle } = useUser();
  const devOverride = isDevelopmentMode() && isSettingsV2DevOverrideOn();

  return {
    isSettingsV2Enabled: Boolean(features_toggle?.settings_v2) || devOverride,
    isCompanySettingsV2Enabled:
      Boolean(features_toggle?.settings_v2_company) || devOverride,
  };
};

export default useSettingsV2Gate;
